import React from 'react'
import styled from 'styled-components'
import { Button } from '@streamr/streamr-layout'
import useConnectedAccounts from './useConnectedAccounts'
import { useEthers } from './EthersProvider'

const UnstyleMigrateButton = ({ className, disabled, onClick }) => {
    const connectedAccounts = useConnectedAccounts()

    const anyWalletConnected = connectedAccounts.length > 0

    const { metamaskProvider } = useEthers()

    const onConnectClick = async () => {
        try {
            metamaskProvider && await metamaskProvider.request({
                method: 'eth_requestAccounts',
            })
        } catch (e) {
            console.error('useConnectEthereum', e)
        }
    }

    return !anyWalletConnected ? (
        <Button
            className={className}
            type="primary"
            disabled={disabled}
            onClick={onConnectClick}
        >
            Connect wallet
        </Button>
    ) : (
        <Button
            className={className}
            type="primary"
            disabled={disabled}
            onClick={onClick}
        >
            Migrate tokens
        </Button>
    )
}

const MigrateButton = styled(UnstyleMigrateButton)``

export default MigrateButton
